<template>
    <b-card :title="title">
        <b-card-body>
            <slot></slot>
            <b-table
                :fields="fields"
                striped
                hover
                responsive
                :items="templates"
            >
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'ListItems',
    mixins: [popupMixins],
    props: ['type', 'title'],

    data() {
        return {
            query: '',
            page: 1,
            fields: [
                {
                    key: 'id',
                    label: 'Actions',
                },
                'name',
                {
                    key: 'completed',
                    label: 'Completed',
                    formatter: value => !!value,
                },
                {
                    key: 'archived',
                    label: 'Archived',
                    formatter: value => !!value,
                },
            ],
        }
    },

    mounted() {},

    methods: {},

    computed: {
        templates() {
            const templates = this.$store.state.checkoffTemplates.templates
            console.log('templates', templates)
            return templates
        },
    },
}
</script>
<style></style>
